import { Callout } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function CalloutDemo() {
  return (
    <Section
      id="callout"
      title="Callout"
      description="Titled, semantic banner for caveats and notices. Renderer for the K2 `callout` block - props are the streamed `{ variant, title?, body }` (body is markdown)."
    >
      <VariantBlock label="Variants">
        <div className="flex w-full flex-col gap-3">
          <Callout variant="info" title="Heads up" body="This studio is in **preview**. Some features may change." />
          <Callout variant="success" title="Published" body="Your experience is live at [aisquare.studio](https://aisquare.studio)." />
          <Callout variant="warning" title="Quota" body="You are at 80% of your monthly generation quota." />
          <Callout variant="error" title="Generation failed" body="The model timed out. Try a shorter prompt." />
          <Callout variant="tip" title="Tip" body="Pin a source to keep it in context across turns." />
        </div>
      </VariantBlock>

      <VariantBlock label="Body-only (no title)">
        <div className="flex w-full flex-col gap-3">
          <Callout variant="info" body="A short inline note with a `code` span and a [link](https://example.com)." />
        </div>
      </VariantBlock>
    </Section>
  );
}
